import { CheckCircle } from "@mui/icons-material";
import { Box, FormLabel } from "@mui/material";
import { Typography } from "@mui/material";
import { Avatar } from "@mui/material";
import { Grid } from "@mui/material";
import { RadioGroup } from "@mui/material";
import Radio, { radioClasses } from "@mui/joy/Radio";
import Sheet from "@mui/joy/Sheet";

const LocationMenu = ({ location, setLocation, setMainview }) => {
  const styleMove = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 640,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 10,
    p: 4,
  };
  const handleImg = (props) => {
    switch (props.value) {
      case "store":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/store.png?alt=media&token=3eb9f9f5-cbbb-44c0-9e2f-a93c13d6bacd";
      case "van":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/van.png?alt=media&token=6fe6cd9d-5661-4c07-948b-c970dbd84c5e";
      case "web":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/web.png?alt=media&token=590439c9-8de2-4c81-b533-354dc659364f";
      case "amazon":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/amazon.png?alt=media&token=20143abb-5342-4a1a-a275-dc16d7b3fb75";
      default:
        return "";
    }
  };

  return (
    <Box sx={styleMove}>
      <Grid style={{ textAlign: "center" }}>
        <Grid>
          <Typography variant="h5" sx={{ color: "purple" }}>
            Cart
          </Typography>
        </Grid>
        <Box padding={1.5}>
          <Grid>
            <Box sx={{ display: "flex", gap: 6 }}>
              <RadioGroup
                aria-label="platform"
                defaultValue="store"
                overlay="true"
                name="platform"
                sx={{
                  flexDirection: "row",
                  gap: 2,
                  [`& .${radioClasses.checked}`]: {
                    [`& .${radioClasses.action}`]: {
                      inset: -1,
                      border: "3px solid",
                      borderColor: "primary.500",
                    },
                  },
                  [`& .${radioClasses.radio}`]: {
                    display: "contents",
                    "& > svg": {
                      zIndex: 2,
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      bgcolor: "background.body",
                      borderRadius: "50%",
                    },
                  },
                }}
              >
                {["store", "van", "web", "amazon"].map((value) => (
                  <Sheet
                    key={value}
                    sx={{
                      borderRadius: "md",
                      bgcolor: "background.body",
                      boxShadow: "sm",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1.5,
                      p: 2,
                      minWidth: 120,
                    }}
                  >
                    <Radio
                      id={value}
                      value={value}
                      checked={value === location}
                      onChange={(e) => setLocation(e.target.value)}
                      checkedIcon={<CheckCircle />}
                    />

                    <Avatar
                      variant="soft"
                      size="sm"
                      src={handleImg({ value })}
                    />

                    <FormLabel htmlFor={value}> {value} </FormLabel>
                  </Sheet>
                ))}
              </RadioGroup>
            </Box>
          </Grid>
        </Box>
      </Grid>
      {location === "" ? "" : setMainview(true)}
    </Box>
  );
};

export default LocationMenu;
